const funderDetailsActionTypes = {
	/***************** START GET FUNDER LIST ****************** */
	GET_FUNDER_DETAILS_LIST_START: 'get_funder_details_list_start',
	GET_FUNDER_DETAILS_LIST_SUCCESS: 'get_funder_details_list_success',
	GET_FUNDER_DETAILS_LIST_FAILURE: 'get_funder_details_list_failure',
	GET_FUNDER_DETAILS_LIST_RESET: 'get_funder_details_list_reset',
	GET_FUNDER_DETAILS_LIST_CHANGED: 'get_funder_details_list_changed',
	/***************** END GET FUNDER LIST ****************** */

	/***************** START ADD FUNDER DETAILS ****************** */
	ADD_FUNDER_DETAILS_START: 'add_funder_details_start',
	ADD_FUNDER_DETAILS_SUCCESS: 'add_funder_details_success',
	ADD_FUNDER_DETAILS_FAILURE: 'add_funder_details_failure',
	ADD_FUNDER_DETAILS_RESET: 'add_funder_details_reset',
	ADD_FUNDER_DETAILS_CHANGED: 'add_funder_details_changed',
	/***************** END ADD FUNDER DETAILS ****************** */

	/***************** START UPDATE FUNDER DETAILS ****************** */
	UPDATE_FUNDER_DETAILS_START: 'update_funder_details_start',
	UPDATE_FUNDER_DETAILS_SUCCESS: 'update_funder_details_success',
	UPDATE_FUNDER_DETAILS_FAILURE: 'update_funder_details_failure',
	UPDATE_FUNDER_DETAILS_RESET: 'update_funder_details_reset',
	UPDATE_FUNDER_DETAILS_CHANGED: 'update_funder_details_changed',
	/***************** END UPDATE FUNDER DETAILS ****************** */

	/***************** START DELETE FUNDER DETAILS ****************** */
	DELETE_FUNDER_DETAILS_START: 'delete_funder_details_start',
	DELETE_FUNDER_DETAILS_SUCCESS: 'delete_funder_details_success',
	DELETE_FUNDER_DETAILS_FAILURE: 'delete_funder_details_failure',
	DELETE_FUNDER_DETAILS_RESET: 'delete_funder_details_reset',
	DELETE_FUNDER_DETAILS_CHANGED: 'delete_funder_details_changed',
	/***************** END DELETE FUNDER DETAILS ****************** */
	/************** FETCH INVESTMENT PRODUCT INVESTMENT AMOUNT START ************************** */
	FETCH_INVESTMENT_PRODUCT_INVESTMENT_AMOUNT_START:
		'fetch_investment_product_investment_amount_start',
	FETCH_INVESTMENT_PRODUCT_INVESTMENT_AMOUNT_SUCCESS:
		'fetch_investment_product_investment_amount_success',
	FETCH_INVESTMENT_PRODUCT_INVESTMENT_AMOUNT_FAILURE:
		'fetch_investment_product_investment_amount_failure',
	FETCH_INVESTMENT_PRODUCT_INVESTMENT_AMOUNT_RESPONSE_RESET:
		'fetch_investment_product_investment_amount_response_reset_start',
	FETCH_INVESTMENT_PRODUCT_INVESTMENT_AMOUNT_RESPONSE_CHANGED:
		'fetch_investment_product_investment_amount_response_changed',
	/************** FETCH INVESTMENT PRODUCT INVESTMENT AMOUNT END ************************** */

	/************** FETCH ALL INVESTMENT MADE LIST START ************************** */
	FETCH_ALL_INVESTMENT_MADE_LIST_START: 'fetch_all_investment_made_list_start',
	FETCH_ALL_INVESTMENT_MADE_LIST_SUCCESS: 'fetch_all_investment_made_list_success',
	FETCH_ALL_INVESTMENT_MADE_LIST_FAILURE: 'fetch_all_investment_made_list_failure',
	FETCH_ALL_INVESTMENT_MADE_LIST_RESPONSE_RESET:
		'fetch_all_investment_made_list_response_reset_start',
	FETCH_ALL_INVESTMENT_MADE_LIST_RESPONSE_CHANGED:
		'fetch_all_investment_made_list_response_changed',
	/**************FETCH ALL INVESTMENT MADE LIST  END ************************** */

	/************** FETCH ALL INVESTMENT REPAYMENT LIST START ************************** */
	FETCH_ALL_INVESTMENT_REPAYMENT_LIST_START: 'fetch_all_investment_repayment_list_start',
	FETCH_ALL_INVESTMENT_REPAYMENT_LIST_SUCCESS: 'fetch_all_investment_repayment_list_success',
	FETCH_ALL_INVESTMENT_REPAYMENT_LIST_FAILURE: 'fetch_all_investment_repayment_list_failure',
	FETCH_ALL_INVESTMENT_REPAYMENT_LIST_RESPONSE_RESET:
		'fetch_all_investment_repayment_list_response_reset_start',
	FETCH_ALL_INVESTMENT_REPAYMENT_LIST_RESPONSE_CHANGED:
		'fetch_all_investment_repayment_list_response_changed',
	/**************FETCH ALL INVESTMENT REPAYMENT LIST  END ************************** */

	/************** CREATE INVESTOR MADE START ************************** */
	CREATE_INVESTOR_MADE_START: 'create_investor_made_start',
	CREATE_INVESTOR_MADE_SUCCESS: 'create_investor_made_success',
	CREATE_INVESTOR_MADE_FAILURE: 'create_investor_made_failure',
	CREATE_INVESTOR_MADE_RESET: 'create_investor_made_reset_start',
	CREATE_INVESTOR_MADE_CHANGED: 'create_investor_made_changed',
	/**************CREATE INVESTOR MADE END ************************** */

	/************** GET INVESTOR DETAILS START ************************** */
	GET_INVESTORS_DETAILS_START: 'get_investors_details_start',
	GET_INVESTORS_DETAILS_SUCCESS: 'get_investors_details_success',
	GET_INVESTORS_DETAILS_FAILURE: 'get_investors_details_failure',
	GET_INVESTORS_DETAILS_RESET: 'get_investors_details_reset_start',
	GET_INVESTORS_DETAILS_CHANGED: 'get_investors_details_changed',
	/************** GET INVESTOR DETAILS END ************************** */

	/************** GET BRANCH ACCOUNT LIST START ************************** */
	GET_BRANCH_ACCOUNT_LIST_START: 'get_Branch_Account_List_start',
	GET_BRANCH_ACCOUNT_LIST_SUCCESS: 'get_Branch_Account_List_success',
	GET_BRANCH_ACCOUNT_LIST_FAILURE: 'get_Branch_Account_List_failure',
	GET_BRANCH_ACCOUNT_LIST_RESET: 'get_Branch_Account_List_reset_start',
	GET_BRANCH_ACCOUNT_LIST_CHANGED: 'get_Branch_Account_List_changed',
	/************** GET BRANCH ACCOUNT LIST END ************************** */

	/************** Get Repayment Schedule START ************************** */
	GET_REPAYMENT_SCHEDULE_START: 'get_Repayment_Schedule_List_start',
	GET_REPAYMENT_SCHEDULE_SUCCESS: 'get_Repayment_Schedule_List_success',
	GET_REPAYMENT_SCHEDULE_FAILURE: 'get_Repayment_Schedule_List_failure',
	GET_REPAYMENT_SCHEDULE_RESET: 'get_Repayment_Schedule_List_reset_start',
	GET_REPAYMENT_SCHEDULE_CHANGED: 'get_Repayment_Schedule_List_changed',
	/************** Get Repayment Schedule END ************************** */
};

export default funderDetailsActionTypes;
